import { Paper } from "@mui/material";

import { formatNumberBasedOnUser } from "../../utils/namesManipulation";
import { cn } from "../../utils/styling";
import { GeneralChartLegend } from "./GeneralChartLegend";

export const ColorBar = ({ className, colorScale, max, min }) => {
  return (
    <div className={`fixed right-5 top-1/2 flex h-3/4 w-8 -translate-y-1/2 flex-col items-center ${className}`}>
      <div className="mb-1 font-ds-body-semibold-md">{formatNumberBasedOnUser(max)}</div>
      <div
        className="h-full w-5 rounded-md"
        style={{
          background: `linear-gradient(${colorScale(1).hex()}, ${colorScale(0.5).hex()}, ${colorScale(0).hex()})`,
        }}
      />
      <div className="mt-1 font-ds-body-semibold-md">{formatNumberBasedOnUser(min)}</div>
    </div>
  );
};

export const CategoricalColorBar = ({ className, colorsData, onLegendClick }) => {
  return (
    <Paper
      className={cn(
        "fixed right-5 top-1/2 max-h-[75%] w-max max-w-[50%] -translate-y-1/2 overflow-y-auto bg-lds-surface-muted p-3 opacity-90 backdrop-blur-xl",
        className
      )}
    >
      <GeneralChartLegend
        className="flex-nowrap items-start "
        direction="column"
        legends={colorsData}
        onLegendClick={(legend) => onLegendClick(legend.label)}
        showValue={false}
      />
    </Paper>
  );
};
